import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Box sx={{ bgcolor: "background.paper", alignItems: "center", p: 2 }} component="footer"> 
      <Typography
        variant="subtitle1"
        align="center"
        color="text.secondary"
        component="p"
        fontSize={20}
      >
        {t("common.thanks")} {`Copyright © Wheelsky ${new Date().getFullYear()}`}
      </Typography>
    </Box>
  );
}
